import type { ReactNode } from "react";
import { useSession } from "@/services/auth";
import { Navigate, useLocation } from "react-router";
import { Loader2 } from "lucide-react";
import { SessionRecovery } from "./session-recovery";

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRoles?: string[];
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isLoading, isLoggedIn, sessionError, customer } = useSession();
  const location = useLocation();
  if (isLoading) {
    return (
      <div className="flex flex-1 h-screen justify-center items-center">
        <Loader2 className="w-10 h-10 animate-spin" />
      </div>
    );
  }

  if (sessionError) return <SessionRecovery />;

  if (!isLoggedIn) {
    // Save the current location to return after login
    return <Navigate to="/" state={{ returnTo: location.pathname }} replace />;
  }

  // Redirect to onboarding if customer has no billing record
  // Skip if already on an onboarding page to avoid redirect loop
  if (
    customer &&
    !customer.billing?.id &&
    !location.pathname.startsWith("/onboarding")
  ) {
    return <Navigate to="/onboarding/step-1" replace />;
  }

  return children;
}
